import React from 'react';

import WrappedBase from './WrappedBase';
import MembershipConflictModal from '../containers/MembershipConflictModal';

export default class MembershipConflictModalWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <MembershipConflictModal {...this.props} />
      </WrappedBase>
    );
  }
}
